<template>
    <v-container grid-list-xs fluid>
        <v-card>
            <v-toolbar dark color="secondary" dense>
                <v-spacer></v-spacer>
                <v-toolbar-title class="white--text"
                    >Confirm Fuel Statement</v-toolbar-title
                >
                <v-spacer></v-spacer>
                <v-btn icon left to="/administration/fuel/fuel-statement"
                    ><v-icon>mdi-arrow-left</v-icon></v-btn
                >
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-data-table
                    dense
                    :headers="headers"
                    :items="data"
                    class="elevation-1 tbl-fuel"
                    disable-sort
                    :show-first-last-page="false"
                    :show-current-page="false"
                    height="250px"
                >
                    <template v-slot:top>
                        <v-toolbar dark color="secondary" dense>
                            <v-spacer></v-spacer>
                            <v-toolbar-title class="white--text"
                                >Fuel Statement Aggregates</v-toolbar-title
                            >
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                    <template v-slot:footer.page-text>
                        <v-btn
                            color="primary"
                            dark
                            class="ma-2"
                            @click="postFuelSt"
                        >
                            Save Fuel Statement
                        </v-btn>
                    </template>
                    <template v-slot:item.action="{ item, index }">
                        <v-icon
                            small
                            class="mx-3"
                            @click="deleteitem(item, index)"
                            >mdi-arrow-down-circle</v-icon
                        >
                        <!-- <v-icon small @click="deleteItem(item)">mdi-delete</v-icon> -->
                    </template>
                </v-data-table>
                <br />
                <v-data-table
                    dense
                    :headers="headers"
                    :items="down"
                    class="elevation-1"
                    hide-default-footer
                    disable-sort
                    disable-pagination
                >
                    <template v-slot:top>
                        <v-toolbar dark color="secondary" dense>
                            <v-spacer></v-spacer>
                            <v-toolbar-title class="white--text"
                                >Fuel Statement Disaggregated</v-toolbar-title
                            >
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.action="{ item, index }">
                        <v-icon
                            small
                            class="mx-3"
                            @click="returnItem(item, index)"
                            >mdi-arrow-up-circle</v-icon
                        >
                        <!-- <v-icon small @click="deleteItem(item)">mdi-delete</v-icon> -->
                    </template>
                </v-data-table>
            </v-container>
        </v-card>
    </v-container>
</template>
<script>
import axios from 'axios';
export default {
    data: function() {
        return {
            data: [],
            StNum: '',
            headers: [
                { text: 'Actions', value: 'action' },
                { text: 'Driver', value: 'shift_detail.driver.Name' },
                { text: 'Type', value: 'expense_type.Type' },
                { text: 'Date', value: 'shift_detail.shift_header.Date' },
                { text: 'Invoice No.', value: 'InvoiceNo' },
                { text: 'QTY', value: 'Qty' },
                { text: 'GST', value: 'GST' },
                { text: 'Total', value: 'Total' },
                { text: 'Actual Price', value: 'ActualPrice' },
                { text: 'Actual Cost', value: 'ActualCost' }
            ],
            down: []
        };
    },
    mounted() {
        console.log(this.$store.state.fuelStatement);
        if (
            this.$store.state.fuelStatement.data == undefined ||
            this.$store.state.fuelStatement.StNum == undefined
        ) {
            this.$router.push('/Administration/fuel/fuel-statement');
        }
        this.StNum = this.$store.state.fuelStatement.StNum;
        this.Fixet();
    },
    methods: {
        Fixet: function() {
            this.data = this.$store.state.fuelStatement.data;
            this.data.forEach(element => {
                element.Qty = Number(element.Qty).toFixed(2);
                element.GSTTruckFuelStatement = Number(element.GST).toFixed(2);
                element.Total = Number(element.Total).toFixed(2);
            });
            console.log(this.data);
        },
        deleteitem: function(itm, index) {
            this.down.push(itm);
            this.data.splice(index, 1);
        },
        returnItem: function(itm, index) {
            this.data.push(itm);
            this.down.splice(index, 1);
        },
        postFuelSt: function() {
            this.$store.state.isLoading = true;
            var params = {
                Statement: this.data,
                StNum: parseInt(this.StNum)
            };
            axios
                .post('fuel-expense/statement/confirm', params)
                .then(response => {
                    console.log(response.status);
                    this.$store.state.fuelStatement = [];
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Fuel Posted Successfully'
                    });
                    console;

                    this.$router.push('/Administration/fuel/fuel-statement');
                    this.$store.state.isLoading = false;
                })
                .catch(error => {
                    this.$store.state.isLoading = false;
                    this.$store.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'An error has ocurred, please try again.'
                    });
                    console.log(error);
                });
        }
    }
};
</script>
<style>
.tbl-fuel .v-data-footer__select {
    display: none;
}
.tbl-fuel .v-data-footer__icons-before {
    display: none;
}
.tbl-fuel .v-data-footer__icons-after {
    display: none;
}

.tbl-fuel .v-data-footer__pagination {
    width: 100%;
}
.tbl-fuel button {
    float: right;
}
</style>
